<template>
    <h1 class="brand-title">
        <span class="text-cost-red">Save</span>
        <span class="text-black">At</span>
        <span class="text-cost-red">Cost</span>
        <span class="text-cost-blue">.co</span>
    </h1>
</template>

<style scoped>
.brand-title {
    @apply text-4xl font-bold text-center mb-4;
}
</style>